import { Button, Stack } from '@mui/material';

import { getEventFeedbackUrl } from 'constants/feedback.constants';
import { useLocale } from 'hooks/useLocale';
import { useModalControl } from 'hooks/useModalControl';

import SettingsLink from 'components/@account/SettingsLink';
import ContactDialog from 'components/@common/ContactDialog';
import LinkUnstyled from 'components/@common/LinkUnstyled';

const SettingLinksList = () => {
  const { locale } = useLocale();
  const { open, onClose, onOpen } = useModalControl();

  return (
    <Stack
      sx={{
        gap: 1,
      }}
    >
      <SettingsLink
        iconName="QuestionCircle"
        intlId="account.settings.help"
        component={Button}
        onClick={onOpen}
      />
      <ContactDialog open={open} onClose={onClose} />
      <SettingsLink
        iconName="Bulb"
        intlId="event.settings.missinginfo"
        component={LinkUnstyled}
        href={getEventFeedbackUrl(locale)}
        target="_blank"
      />
    </Stack>
  );
};

export default SettingLinksList;
